import { useNavigate } from "react-router-dom";
import DashboardPage from "./DashboardPage";
import OverviewLanding from "../../components/Dashboard/OverviewLanding";

export default function DashboardsHome() {
  const navigate = useNavigate();

  return (
    <DashboardPage
      title="Dashboard Geral"
      subtitle="Visão geral do portfólio — escolha um painel abaixo"
      info="Página inicial com os indicadores de alto nível e atalhos para cada painel detalhado."
    >
      <OverviewLanding onNavigate={navigate} />
    </DashboardPage>
  );
}
